module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/companies-mobile-6f2398c33569fdd5bce62edc6600d8ee.svg";